/* eslint-disable arrow-body-style */

import type { GetPieRadioDataConfig, PieRatioData } from './types';

export function isNullOrUndefined(v: any): boolean {
  return v === null || v === void 0;
}

export function round(num: number, decimals = 2): number {
  const _num = Number(num);
  let _decimals;
  if (Number.isNaN(_num)) return num;
  _decimals = Number(decimals);
  _decimals = Number.isNaN(_decimals) ? 2 : _decimals;
  const _temp = Math.pow(10, _decimals);
  return Math.round(_num * _temp) / _temp;
}

export function getNumberValue(v: any): number {
  if (isNullOrUndefined(v)) return 0;
  const valueTemp = Number(v);
  return Number.isNaN(valueTemp) ? 0 : valueTemp;
}

export function getPieRadioData(v: number, config: GetPieRadioDataConfig): PieRatioData {
  const _v = getNumberValue(v);
  const { baseTotal = 100, extraTotal = 30, maxExtraTotalActual = 200 } = config || {};

  /** ******************* 100%百分数以内 *********************/
  // 每1%需要渲染的宽度 = 总宽度 / 总宽度所代表的百分比数
  const baseItem = baseTotal / 100;
  // 高亮的百分数，对传入的百分数 做上限处理，上限为100%百分数
  const baseActivated = Math.min(_v, 100);
  // 未高亮的百分数
  const baseDeactivated = 100 - baseActivated;
  /** ******************* 100%百分数以内 *********************/

  /** ******************* 超出100%百分数 *********************/
  // 超出100%的百分数
  const extra = Math.max(_v - 100, 0);
  // 总宽度 代表的 总百分数，即 125% 超出 100% 多 25%，对应总百分数就是 100%，250% 超出100% 多 150%，对应总百分数为 200%
  let extraTotalActual = Math.max(Math.ceil(extra / 100) * 100, 100);
  // 总宽度 代表的 总百分数 做上限处理，最大值为maxExtraTotalActual
  extraTotalActual = Math.min(extraTotalActual, maxExtraTotalActual);
  // 每1%需要渲染的宽度 = 总宽度 / 总宽度所代表的百分比数
  const extraItem = extraTotal / extraTotalActual;
  // 高亮的百分数
  const extraActivated = Math.min(extra, maxExtraTotalActual);
  // 未高亮的百分数
  const extraDeactivated = extraTotalActual - extraActivated;
  /** ******************* 超出100%百分数 *********************/

  return {
    // pie饼状图中 渲染100%百分数以内那部分的渲染配置
    base: {
      // 高亮 = 百分比数 * 每1%需要渲染的宽度
      activated: round(baseActivated * baseItem),
      // 未高亮 = 百分数 * 每1%需要渲染的宽度
      deactivated: round(baseDeactivated * baseItem),
    },
    // pie饼状图中 渲染超出100%百分数以内那部分的渲染配置
    extra: {
      // 高亮 = 百分比数 * 每1%需要渲染的宽度
      activated: round(extraActivated * extraItem),
      // 未高亮 = 百分比数 * 每1%需要渲染的宽度
      deactivated: round(extraDeactivated * extraItem),
    },
  };
}

export function getPercentagePieChartSeriesData(value: number): any {
  const { base, extra } = getPieRadioData(value, {
    baseTotal: 100,
    extraTotal: 30,
  });
  const { activated: baseActivated = 0, deactivated: baseDeactivated = 100 } = base || {};
  const { activated: extraActivated = 0, deactivated: extraDeactivated = 30 } = extra || {};

  return [
    {
      value: baseActivated,
      name: 'actual1',
      itemStyle: {
        color: '#376AE7',
      },
    },
    {
      value: baseDeactivated,
      name: 'actual2',
      itemStyle: {
        color: '#f2f3f5',
      },
    },
    {
      value: 2,
      name: 'splitter',
      itemStyle: {
        color: '#fff',
      },
    },
    {
      value: extraActivated,
      name: 'extra1',
      itemStyle: {
        color: '#77E097',
      },
    },
    {
      value: extraDeactivated,
      name: 'extra2',
      itemStyle: {
        color: '#f2f3f5',
      },
    },
    {
      // pie总共百分比数 是 264，所以 另一半隐藏的占132
      value: 132,
      name: 'mask',
      itemStyle: {
        color: 'transparent',
      },
    },
  ];
}
